const platArray = (arr) => {
    arr = arr || [];
    if(arr.length == 0){
        return arr;
    }
    let narr = [];
    for(let i=0,len=arr.length;i<len;i++){
        if(Array.isArray(arr[i])){
            narr = narr.concat(arr[i]);
        }
        else{
            narr.push(arr[i]);
        }
    }
    return narr;
}
//action creator生成器
export const makeActionCreator = (type) => {
    return (data) => {
        return {
            type : type,
            payload : data
        }
    }
}
/*
    async action type生成器
    生成的type,参数(MODEL)加固定后缀
    {
        "{MODEL}_REQUEST" : '{MODEL}_REQUEST',
        "{MODEL}_SUCCESS" : '{MODEL}_SUCCESS',
        "{MODEL}_FAIL" : '{MODEL}_FAIL',
        "{MODEL}_CLEAR" : '{MODEL}_CLEAR'
    }
*/
const SPLITGAP = '_';
const TYPESUFFIX = ['request', 'success', 'fail', 'clear'];
const TYPES = {
    'CLEAR_ALL' : 'CLEAR_ALL'
};
//actin type生成器
export const makeActionType = (model, extra) => {
    let upModel = Array.isArray(model) ? model : [model];
    upModel = upModel.map(function(item){return item.toUpperCase()}).join(SPLITGAP);
    let arr = TYPESUFFIX.concat();
    if(typeof extra == 'string'){
        arr.push(extra);
    }
    else if(Array.isArray(extra)){
        arr = arr.concat(extra);
    }
    let newTypes = arr.map(function(item, n){
        return upModel + SPLITGAP + item.toUpperCase();
    });
    for(let i=0,len=newTypes.length;i<len;i++){
        if(TYPES[newTypes[i]]){
            throw new Error('this model ‘'+ model +'’ & ‘'+ newTypes[i].toLowerCase() +'’ is exist');
        }
        TYPES[newTypes[i]] = newTypes[i];
    }
}
//获取action type
export const getActionType = (...args) => {
    let upModel = [].slice.call(args);
    //参数中存在数组的情况，拍扁
    upModel = platArray(upModel);
    upModel = upModel.map(function(item){
        return item.toUpperCase();
    })
    return TYPES[upModel.join(SPLITGAP)];
}
export {TYPES} 

//驼峰式生成
export const makeCamelCase = (item) => {
    if(typeof item !== 'string'){
        return item;
    }
    return item.charAt(0).toUpperCase() + item.slice(1);
}



// WEBPACK FOOTER //
// ./client/util/redux.js